const MAX_RATING = 5;

const formatNumber = (number) => {
    return number >= 1000
        ? (number / 1000).toFixed(1) + "K"
        : number.toString();
};

export function updateReviewRatingSummarySection(
    rating,
    userRating,
    userReview,
    ratings,
    formRatings
) {
    if (userRating !== undefined && userRating !== 0) {
        $("#js--updated-review-text").text(userReview);
        $("#js--rating").parent().hide();
        $("#js--updated-rating").parent().removeClass("d-none");

        $([...ratings.children]).on("mouseleave", function () {
            if (rating > 0) {
                for (let i = 0; i < rating; i++) {
                    $([...ratings.children][i])
                        .removeClass("ion-ios-star-outline")
                        .addClass("ion-ios-star");
                }
            }
        });

        for (let i = 0; i < userRating; i++) {
            if (ratings) {
                $([...ratings.children][i])
                    .removeClass("ion-ios-star-outline")
                    .addClass("ion-ios-star");
            }

            $([...$("#js--updated-rating i")][i])
                .removeClass("ion-ios-star-outline")
                .addClass("ion-ios-star");

            if (formRatings) {
                $([...formRatings.children][i])
                    .removeClass("ion-ios-star-outline")
                    .addClass("ion-ios-star");
            }
        }
        $("#js--review-writing").val(userReview);
        rating = userRating;
        $("#js--updated-rating").attr("data-user-rating", userRating);
        $("#js--updated-review-text").attr("data-user-review", userReview);
    }
}

export function getUserReviewData(rating, productId, ratings, formRatings) {
    return $.ajax({
        type: "GET",
        url: `/review-rating-by-user?productId=${productId}`,
        success: function (response) {
            const { rating: userRating, review } = response || {};
            updateReviewRatingSummarySection(
                rating,
                userRating,
                review,
                ratings,
                formRatings
            );
            $("#js--user-gives-rating").val(userRating > 0);
            $("#js--user-gives-review").val(!!review);
        },
        error: function (error) {},
    });
}

export function getRatingGraphData(productId) {
    let graphTemplate = "";
    $.ajax({
        type: "GET",
        url: `/ratingchart?id=${productId}`,
        success: function (response) {
            response.map((item) => {
                const { count, percentage, value } = item;
                graphTemplate += `<div class="graph-item">
                                    <span class="graph-item__icon">
                                        ${new Array(value + 1).join(
                                            '<i class="ion-ios-star"></i>'
                                        )}${new Array(5 - value + 1).join(
                    '<i class="ion-ios-star-outline"></i>'
                )}
                                    </span>
                                    <span class="graph-item__star">${value}</span>
                                    <div class="progress">
                                        <div class="progress-bar" role="progressbar" style="width: ${percentage}%" aria-valuenow="${percentage}" aria-valuemin="0" aria-valuemax="100"></div>
                                    </div>
                                    <p class="graph-item__counter">${formatNumber(
                                        count
                                    )}</p>
                                </div>`;
            });
            $("#js--rating-graph").html(graphTemplate);
        },
        error: function (error) {},
    });
}

export function showReviewRatingPopup(rating, productId, ratings, formRatings) {
    $("#js--review-rating-popup").fadeIn();
    $("#js--overlay-new").show();
    getUserReviewData(rating, productId, ratings, formRatings);
}

export function hideReviewRatingPopup(
    ratings,
    rating,
    formRatings,
    isEdit = false
) {
    $("#js--review-rating-popup").fadeOut();
    $("#js--overlay-new").hide();
    if (!isEdit) {
        for (let i = 0; i < rating; i++) {
            $([...ratings.children][i])
                .removeClass("ion-ios-star")
                .addClass("ion-ios-star-outline");

            $([...formRatings.children][i])
                .removeClass("ion-ios-star")
                .addClass("ion-ios-star-outline");
        }
    }
    $("#js--review-writing").val("").css("border-color", "#9e9e9e");
    $("#js--review-error").addClass('d-none').text("");
    $("#js--rating-error").addClass('d-none').text("");
    $('.icon-star-wrapper').css('border', 'none');
    $("#js--review-submit").attr("disabled", false).addClass("active");
}

export function validateReviewRating(rating, textElement) {
    if (rating < 3 && textElement.val().trim().length < 25) {
        textElement
            .parents("#js--review-rating-popup")
            .find("#js--review-submit")
            .attr("disabled", true)
            .removeClass("active");
        textElement
            .attr(
                "placeholder",
                "Please write your review (minimum 25 characters"
            )
            .css("border-color", "red");
        textElement
            .next("#js--review-error")
            .removeClass("d-none")
            .text("A review is required of at least 25 characters");
    } else {
        textElement
            .parents("#js--review-rating-popup")
            .find("#js--review-submit")
            .attr("disabled", false)
            .addClass("active");
        textElement
            .attr("placeholder", "Describe your experience (optional)")
            .css("border-color", "#9e9e9e");
        textElement.next("#js--review-error").addClass("d-none").text("");
    }
    if (rating === 0) {
        textElement
            .next("#js--rating-error")
            .removeClass("d-none")
            .text("Please give the rating");
    } else {
        $('#js--rating-error').addClass('d-none').text('');
        $(".icon-star-wrapper").css("border", "none");
    }
}

export function delegateRating(element, rating, ratings) {
    if (rating) {
        $([...ratings.children]).each(function (i, item) {
            $(item)
                .removeClass("ion-ios-star")
                .addClass("ion-ios-star-outline");
        });

        for (let i = 0; i < rating; i++) {
            $([...ratings.children][i])
                .removeClass("ion-ios-star-outline")
                .addClass("ion-ios-star");

            $([...$("#js--form-rating i")][i])
                .removeClass("ion-ios-star-outline")
                .addClass("ion-ios-star");
        }
    }

    $("#js--review-writing").focus();

    validateReviewRating(rating, $("#js--review-writing"));
}

export function reviewImagePopup(element, rating) {
    let popupHtml = "";
    $("#js--review-image-slide").html("");
    $("#js--overlay-new").show();
    $("#js--review-img-viewer-popup").fadeIn();

    let parentItem = $(element).parent(".js--review-img-container");
    rating = $(parentItem).data("rating");

    $("#js--reviewer-name-review-img-viewer").text(
        $(parentItem).data("username")
    );
    $("#js--reviewer-image-review-img-viewer").attr(
        "src",
        $(parentItem).data("user-image")
    );
    $("#js--reviewer-date-review-img-viewer").text($(parentItem).data("date"));

    if ($(parentItem).data("is-verified")) {
        $("#js--verified-purchase-review-img-viewer")
            .removeClass("d-none")
            .addClass("d-flex");
    } else {
        $("#js--verified-purchase-review-img-viewer")
            .removeClass("d-flex")
            .addClass("d-none");
    }

    let starRatings = [];
    for (let i = 0; i < rating; i++) {
        starRatings.push(`<i class="ion-ios-star"></i>`);
    }
    $("#js--reviewer-rating-review-img-viewer").html(starRatings.join(""));

    $(element)
        .parent(".js--review-img-container")
        .children()
        .each((index, data) => {
            popupHtml +=
                `<div class="item carousel-item ${
                    index == 0 ? "active" : ""
                }" >` +
                '<img src="' +
                data.attributes[0].value +
                '"  alt="image" class="review-img d-block">' +
                "</div>";
        });

    $("#js--review-image-slide").html(popupHtml);
    $("#js--review-image-slide-control").carousel($(element).data("index"));
}

export function inputReviewImage(e, reviewImagesInput) {
    let imgFiles = e.target.files;
    let imgFilesLen = imgFiles.length;
    let acceptedSize = 10240000;
    let imageViewHtml = "";

    if (imgFilesLen > 0) {
        if (reviewImagesInput.length < 5) {
            for (let i = 0; i < imgFilesLen; i++) {
                const isSizeUploadable = imgFiles[i].size <= acceptedSize;
                const isAllowedExtensions =
                    $.inArray(imgFiles[i].name.split(".").pop().toUpperCase(), [
                        "JPG",
                        "JPEG",
                        "BMP",
                        "PNG",
                    ]) !== -1;

                if (
                    isSizeUploadable &&
                    isAllowedExtensions &&
                    reviewImagesInput.length < 5
                ) {
                    reviewImagesInput.push({
                        name: imgFiles[i].name,
                        file: imgFiles[i],
                    });
                }
            }
        }

        reviewImagesInput.forEach((data, i) => {
            imageViewHtml +=
                `<div class="item" data-name="${data.name}">` +
                '<img src="' +
                URL.createObjectURL(data.file) +
                '" alt="review image">' +
                ' <i class="ion-close close-btn js--review-upload-img-close"></i>' +
                "</div>";
        });

        $("#js--review-image-selected").html(imageViewHtml);
        $("#js--review-image-input-count").text(reviewImagesInput.length);
    }
}

export function submitReviewRating(params) {
    let {
        productId,
        rating,
        CSRF,
        reviewImagesInput,
        ratings,
        formRatings,
        noOfRatings,
        noOfReviews,
        reviewPath,
        userImageUrl,
        imageFilePath,
    } = params;

    let review = $("#js--review-writing").val().trim();
    let reviewImageFiles = reviewImagesInput;
    let reviewImageFilesSize = reviewImageFiles.length;
    let reviewImages = new FormData();
    let isReviewEmpty = review === "";

    reviewImages.append("productId", productId);
    reviewImages.append("rating", rating);
    reviewImages.append("review", review);
    reviewImages.append("source", "DETAILS");

    for (let i = 0; i < reviewImageFilesSize; i++) {
        reviewImages.append("reviewImages", reviewImagesInput[i].file);
    }

    reviewImages.append("_tk", CSRF);

    $.ajax({
        type: "POST",
        url: "/review-rating-submit",
        data: reviewImages,
        contentType: false,
        processData: false,
        success: function (message) {
            $("#js--review-message-text").html(message);
            $("#js--message-review-details")
                .slideDown()
                .removeClass("alert-danger")
                .addClass("alert-success");

            showReview(
                `${reviewPath}${productId}/`,
                1,
                userImageUrl,
                imageFilePath
            );

            $("#review-image-input").val("");
            $("#js--review-image-selected").html("");
            $("#js--review-image-input-count").text(0);
            reviewImagesInput = [];

            $("#js--rating").parent().hide();
            $("#js--btn-update-review").show();
            $("#js--updated-review-text").html(review).show();
            $("#js--updated-rating").parent().removeClass("d-none");

            $([...$("#js--updated-rating i")]).each((i, item) => {
                $(item)
                    .removeClass("ion-ios-star")
                    .addClass("ion-ios-star-outline");
            });

            for (let i = 0; i < rating; i++) {
                $([...$("#js--updated-rating i")][i])
                    .removeClass("ion-ios-star-outline")
                    .addClass("ion-ios-star");
            }

            if ($("#js--user-gives-rating").val() == "false") {
                noOfRatings += 1;
            }

            if (
                $("#js--user-gives-review").val() == "false" &&
                !isReviewEmpty
            ) {
                noOfReviews += 1;
            }

            $("#js--user-gives-rating").val(rating > 0);
            $("#js--user-gives-review").val(
                !!$("#js--review-writing").val().trim()
            );

            $("#js--rating-review-count-summary").text(
                `${noOfRatings} ${
                    noOfRatings > 1 ? "Ratings" : "Rating"
                } and ${noOfReviews} ${noOfReviews > 1 ? "Reviews" : "Review"}`
            );

            hideReviewRatingPopup(ratings, rating, formRatings);
        },
        error: function () {},
    });
}

function generateReviewTemplate(
    data,
    starRatings,
    userReviewImages,
    userPhoto,
    userReviewDetail,
    imgFilePath
) {
    const {
        userName,
        reviewDate,
        verifiedPurchase,
        userRating,
        reviewId,
        posVote,
        negVote,
    } = data;

    return `<div class="review">
                <div class="user-info d-flex align-items-center">
                    <img class="user-img" src="${userPhoto}" alt="user-img">

                    <div class="info">
                        <div class="name-date">
                            <p class="d-inline-block name">By <span>${userName}</span>, </p>
                            <p class="date d-inline-block"> ${reviewDate}</p>
                        </div>
                        <div class="rating-info d-flex align-items-center">
                            <div class="stars mr-2">
                                ${starRatings.join("")}
                            </div>

                            <div class="verified-purchase ${
                                verifiedPurchase ? "d-flex" : "d-none"
                            } align-items-center">
                                <img src="${imgFilePath}/verified-purchase.png" class="mr-1" alt="Verified Purchase icon">
                                <p>Verified Purchase</p>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="review-content">
                    <p class="review-text js--review-content">${userReviewDetail}</p>

                    <p class="read-expander js--review-read-expand d-none">Read More</p>

                    <div class="review-imgs js--review-img-container" data-username="${userName}" data-date="${reviewDate}" data-is-verified="${verifiedPurchase}" data-user-image="${userPhoto}" data-rating="${userRating}">
                        ${userReviewImages.join("")}
                    </div>
                <div class="align-items-center">
                    <p class="review-helpful" id="js--helpful-review-id-${reviewId}">
                         Was this review helpful to you?
                    </p>
                    <div>
                        <div class="review-like-dislike d-flex align-items-start">
                            <button class="js--vote btn like mr-2 review-helpful" review-id="${reviewId}" data-value="1" id="pos${reviewId}"><img src="${imgFilePath}/svg/like-new.svg" alt="like icon" >  Helpful (<span id="positive-review">${posVote}</span>) </button>
                            <button class="js--vote btn dislike review-helpful" review-id="${reviewId}" data-value="0" id="neg${reviewId}"><img src="${imgFilePath}/svg/like-new.svg" alt="dislike icon">Not Helpful</button>
                        </div>
                    </div>
                </div>
                   
             
            </div>`;
}

export function showReview(url, nthPage, userImageUrl, imgFilePath, filterValue = 'DEFAULT') {
    $(".js--ratings-review__content--review").empty();

    $.ajax({
        type: "GET",
        url: url + nthPage + '?filter=' + filterValue,
        async: false,
        success: function (response) {
            let userPhoto = "";
            let userReviewDetail = "";

            const reviews = response.map((data) => {
                const starRatings = [];
                const userReviewImages = [];

                const {
                    userPhoto: userImage,
                    userRating,
                    isLastPage,
                    reviewImages,
                    reviewDetail,
                    userName,
                    reviewDate,
                    verifiedPurchase,
                    reviewId,
                    posVote,
                    negVote,
                } = data;

                if (
                    userImage != null &&
                    userImage != "null" &&
                    userImage != ""
                ) {
                    userPhoto = userImage.startsWith("https://")
                        ? userImage
                        : `${userImageUrl}/${userImage}`;
                } else {
                    userPhoto = `${imgFilePath}/svg/user.svg`;
                }

                for (let i = 1; i <= MAX_RATING; i++) {
                    starRatings.push(
                        `<i class="ion-ios-star${
                            userRating >= i ? "" : "-outline"
                        }"></i>`
                    );
                }

                if (isLastPage) {
                    $("#js--show-more-reviews").remove();
                }

                if (reviewImages.length > 0) {
                    reviewImages.forEach((imageSource, i) => {
                        userReviewImages.push(
                            `<img src="${imageSource}" alt="review image" class="js--review-img" data-index="${i}">`
                        );
                    });
                }

                userReviewDetail = nl2br(reviewDetail);

                return generateReviewTemplate(
                    data,
                    starRatings,
                    userReviewImages,
                    userPhoto,
                    userReviewDetail,
                    imgFilePath
                );
            });

            $(".js--ratings-review__content--review").html(reviews);

            $(".js--review-content").each((i, ele) => {
                if ($(ele).height() < $(ele).prop("scrollHeight") - 1) {
                    $(ele)
                        .siblings(".js--review-read-expand")
                        .removeClass("d-none");
                }
            });
        },
    });
}

export const nl2br = (str) => str.replace(/(?:\r\n|\r|\n)/g, "<br>");

export function handleExpandReview(e) {
    $(e.target).siblings(".js--review-content").toggleClass("active");
    if ($(e.target).siblings(".js--review-content").hasClass("active")) {
        $(e.target).text("Read Less");
    } else {
        $(e.target).text("Read More");
    }
}

function getReviewVote(reviewId) {
    $.ajax({
        type: "GET",
        url: `/reviewposnegvote/${reviewId}`,
        success: function (response) {
            const { posVote, negVote } = response;
            const totalReview = posVote + negVote;

            const voteCountTemplate = `<span id="js--positive-review-quantity-${reviewId}">${posVote} of ${totalReview}</span> people including you found this review helpful.`;

            if ($("#js--positive-review-quantity-" + reviewId).length === 0) {
                $("#js--helpful-review-id-" + reviewId).html(voteCountTemplate);
            } else {
                $("#js--positive-review-quantity-" + reviewId).html(
                    `${posVote} of ${totalReview}`
                );
            }
            $("#positive-review").html(posVote);
        },
    });
}

export function submitVote(reviewId, value, loginPage, CSRF) {
    $.ajax({
        type: "POST",
        url: `/usefulreview/${reviewId}/${value}`,
        data: "&_tk=" + CSRF,
        success: function (response) {
            const { status } = response;

            if (status === "login") {
                location.href = loginPage;
                return;
            }

            getReviewVote(reviewId);
        },
    });
}
